import { Component, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { FormGroup, FormControl, Validators, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { AppState } from '../../../reducers';


const MIN_LENGTH = 8,
  CASE_REGEX = /[A-Z]/,
  NUMBER_REGEX = /\d/,
  SYMBOL_REGEX = /[^\w\s]/;

@Component({
  standalone: false,
  selector: 'dsp-reset-password',
  templateUrl: 'reset-password.component.html'
})
export class ResetPasswordComponent implements OnInit {
  //@ViewChild(MosInputPasswordRedactionDirective)
  // public password: MosInputPasswordRedactionDirective;

  public form: FormGroup;

  public lengthValid = false;
  public caseValid = false;
  public numberValid = false;
  public symbolValid = false;

  public constructor(
    private readonly store: Store<AppState>
  ) { }

  public ngOnInit(): void {
    this.form = new FormGroup({
      password: new FormControl('', [Validators.required, this.validate()])
    });
  }

  public onReset(): void { }

  public toggleVisible(): void {
    // if (this.password.maskField) {
    //   this.password.maskField = false;
    // } else {
    //   this.password.maskField = true;
    // }
  }

  public validate(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      const password = control.value || '';

      this.lengthValid = password.length >= MIN_LENGTH;
      this.caseValid = CASE_REGEX.test(password);
      this.numberValid = NUMBER_REGEX.test(password);
      this.symbolValid = SYMBOL_REGEX.test(password);

      const valid = this.lengthValid && this.caseValid && this.numberValid && this.symbolValid;
      return (valid) ? null : { password: true };
    };
  }
}
